// - Renders product details including name, image, and price.
// - Displays a "Sale" badge for products categorized under "Sale" with localized text.
// - Wraps the entire tile in a clickable `Link` component for navigation.
// - Uses responsive styling for alignment and spacing within a compact card layout.
// - Integrates with the `Prices` component to display pricing details, including potential discounts.

import Link from '../../atoms/link';
import React from 'react';
import Prices from '../product/product-tile/prices';
import sale from 'public/locales/en/product.json';
import { standalonePrice } from './type';
import Price from '../product/product-list-algolia/components/Algolia-search-Page/price';
import { SmartLink } from 'components/commercetools-ui/atoms/smart-link';

type BasicProduct = {
  name?: string;
  image?: string;
  price?: Record<string, unknown>;
  categoryKey?: {
    [locale: string]: string[];
  };
  slug?: string;
  standalonePrice?: standalonePrice[];
};

type product = {
  product?: BasicProduct;
};
const PopularProductTile = ({ product }: product) => {
  const convertProductNameToUrl = (input: string) => {
    const urlformat = `${input?.toLowerCase()?.replace(/\s+/g, '-')}`;
    const url = urlformat?.endsWith('-') ? urlformat : `${urlformat}-`;
    return url.replace(/,/g, '');
  };
  return (
    <>
      <div className="flex flex-col items-center justify-between p-16">
        <SmartLink href={convertProductNameToUrl(product?.name as string) + product?.slug + '.html'}>
          <div className="p-3">
            <div className="relative mb-4 flex items-center justify-center">
              <img src={product?.image} alt={product?.name} className="h-[240px] w-[240px] object-cover " />
              {product?.categoryKey?.['en-GB']?.includes('Sale') && (
                <button className="absolute right-10 top-10 h-[72px] w-[72px] rounded-full bg-[#fc0000] p-5 font-body text-[22px] font-extrabold leading-4 text-white">
                  {sale.saleButton}
                </button>
              )}
            </div>
            <div className="text-center">
              <p className="font-body text-[14.4px] font-medium leading-[19.2px] sm:text-16">{product?.name}</p>
            </div>
          </div>
        </SmartLink>
        <div className="mb-10 flex h-[48px] items-end text-center">
          <p className="font-body font-bold leading-8 text-primary-black">
            {/* Need to Fix */}
            {/* {CurrencyHelpers.formatForCurrency(price ?? '', locale)} */}
            <Price prices={product?.standalonePrice} className="text-28 sm:text-32" />
            {/* {(product?.standalonePrice?.[0]?.priceGB / 100).toFixed(2)} */}
          </p>
          {/* <Prices price={product?.price} /> */}
        </div>
      </div>
    </>
  );
};

export default PopularProductTile;
